import axiosInstance from "@/boot/axios";

class AuthorRepository {
    constructor() {
        this.PAGINATION_SIZE = 10;
    }

    async create(author) {
        const response = await axiosInstance.post("/v1/author", author);
        return response.data;
    }

    async paginatedSearch(page, searchTerm) {
        try {
            const response = await axiosInstance.get("/v1/author", {
                params: {
                    search: searchTerm,
                    page: page,
                    size: this.PAGINATION_SIZE,
                },
            });
            return response.data;
        } catch {}
    }
}

export default new AuthorRepository();
